import mapValues from 'lodash/mapValues';
import useResizeDetector from 'hooks/useResizeDetector';
import {
  UseElementBreakpointsConfig,
  UseElementBreakpointsResult,
} from './types';

export default function useElementBreakpoints<
  C extends UseElementBreakpointsConfig
>(config: C): UseElementBreakpointsResult<C> {
  const { ref, width } = useResizeDetector();

  const matches = mapValues(config, ({ max = Infinity, min = -Infinity }) => {
    if (width === undefined) {
      return undefined;
    }

    return width >= min && width <= max;
  });

  return { matches, ref };
}
